'use client';
import Page from '@/pages/Login';

export default Page;